import React from "react";
import HeaderOpenData from "./HeaderOpenData";
import FooterOpenData from "./FooterOpenData";
import SearchOpenData from "./beranda/SearchOpenData";
import AboutOpenData from "./beranda/AboutOpenData";


const PagesBerandaOpenData = () => {
    return(
        <div>
            <HeaderOpenData />
            <SearchOpenData />
            <AboutOpenData />
            <FooterOpenData />
        </div>
    )
}

export default PagesBerandaOpenData;